const url = '/exchangeRates';
const Provider = 'ExchangeRates';
const dbModel = 'ExchangeRates';

export { url, Provider, dbModel };

export const TABLE_NAME = 'exchangerates';
